import React from 'react';
import { Heading } from 'components/Typography';
import * as S from './styles';

export interface CardFooterProps {
  /**
   * Footer contents.
   *
   * If this prop is a string, it will be wrapped in `h2`.
   */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Wraps elements passed to Card's `footer` prop to provide layout for the footer
 */
const CardFooter: React.FC<CardFooterProps> = ({ children, className }) => (
  <S.Root className={className}>
    {typeof children === 'string' ? (
      <Heading level={2}>{children}</Heading>
    ) : (
      children
    )}
  </S.Root>
);

export default CardFooter;
